
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

const getErrorPayload = (error) =>
  error.response?.data || { messages: "Đã xảy ra lỗi!" };

export const fetchAuditLogs = createAsyncThunk(
  "auditLogs/fetchAuditLogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("/audit-log-shows", { params });
      return response.data?.data || {};
    } catch (error) {
      return rejectWithValue(getErrorPayload(error));
    }
  }
);

export const fetchAuditLogById = createAsyncThunk(
  "auditLogs/fetchAuditLogById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(`/audit-log-show/${id}`);
      return response.data?.data || null;
    } catch (error) {
      return rejectWithValue(getErrorPayload(error));
    }
  }
);

export const fetchAuditLogSettings = createAsyncThunk(
  "auditLogs/fetchAuditLogSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("/audit-log-setting");
      return response.data?.data || null;
    } catch (error) {
      return rejectWithValue(getErrorPayload(error));
    }
  }
);

export const updateAuditLogRetention = createAsyncThunk(
  "auditLogs/updateAuditLogRetention",
  async (retentionDays, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put("/audit-log-setting-retention", {
        retentionDays,
      });
      return response.data?.data || null;
    } catch (error) {
      return rejectWithValue(getErrorPayload(error));
    }
  }
);

export const updateAuditLogStatus = createAsyncThunk(
  "auditLogs/updateAuditLogStatus",
  async (enabled, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put("/audit-log-setting-status", {
        enabled,
      });
      return response.data?.data || null;
    } catch (error) {
      return rejectWithValue(getErrorPayload(error));
    }
  }
);

const auditLogSlice = createSlice({
  name: "auditLogs",
  initialState: {
    auditLogs: [],
    totalItems: 0,
    totalPage: 0,
    currentPage: 1,
    selectedAuditLog: null,
    settings: null,
    listStatus: "idle",
    detailStatus: "idle",
    settingsStatus: "idle",
    updateStatus: "idle",
    error: null,
    detailError: null,
    settingsError: null,
  },
  reducers: {
    clearSelectedAuditLog: (state) => {
      state.selectedAuditLog = null;
      state.detailStatus = "idle";
      state.detailError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.listStatus = "loading";
        state.error = null;
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.listStatus = "succeeded";
        state.auditLogs = action.payload.auditLogs || [];
        state.totalItems = action.payload.totalItems || 0;
        state.totalPage = action.payload.totalPage || 0;
        state.currentPage = action.payload.currentPage || 1;
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.listStatus = "failed";
        state.error = action.payload;
      })
      .addCase(fetchAuditLogById.pending, (state) => {
        state.detailStatus = "loading";
        state.detailError = null;
        state.selectedAuditLog = null;
      })
      .addCase(fetchAuditLogById.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.selectedAuditLog = action.payload;
      })
      .addCase(fetchAuditLogById.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.detailError = action.payload;
      })
      .addCase(fetchAuditLogSettings.pending, (state) => {
        state.settingsStatus = "loading";
        state.settingsError = null;
      })
      .addCase(fetchAuditLogSettings.fulfilled, (state, action) => {
        state.settingsStatus = "succeeded";
        state.settings = action.payload;
      })
      .addCase(fetchAuditLogSettings.rejected, (state, action) => {
        state.settingsStatus = "failed";
        state.settingsError = action.payload;
      })
      .addCase(updateAuditLogRetention.pending, (state) => {
        state.updateStatus = "loading";
      })
      .addCase(updateAuditLogRetention.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        state.settings = action.payload;
      })
      .addCase(updateAuditLogRetention.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.settingsError = action.payload;
      })
      .addCase(updateAuditLogStatus.pending, (state) => {
        state.updateStatus = "loading";
      })
      .addCase(updateAuditLogStatus.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        state.settings = action.payload;
      })
      .addCase(updateAuditLogStatus.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.settingsError = action.payload;
      });
  },
});

export const { clearSelectedAuditLog } = auditLogSlice.actions;
export default auditLogSlice.reducer;


